<template>
  <div class="process">
    <div class="app-row">
      <ul>
        <li 
          v-on:click="$router.push('/')"
          v-bind:class="{ active: this.currentStep >= 1 }">
          <span>1 Dakcheck</span>
        </li>
        <li 
          v-on:click="routeTo('/verbruik', 1)"
          v-bind:class="{ active: this.currentStep >= 2 }">
          <span>2 Jouw verbruik</span>
        </li>
        <li 
          v-on:click="routeTo('/gegevens', 2)"
          v-bind:class="{ active: this.currentStep >= 3 }">
          <span>3 Jouw gegevens</span>
        </li>
        <li 
          v-on:click="routeTo('/resultaten', 3)"
          v-bind:class="{ active: this.currentStep >= 4 }">
          <span>4 Resultaten</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Process',
    computed: {
      currentStep() {
        return this.$store.getters.get_current_step
      },
      completedSteps() {
        return this.$store.getters.get_completed_steps
      }
    },
    methods : {
      //
      //  Adds step_completed check
      //
      routeTo (path, pageIndex) {
        if( this.completedSteps.includes(pageIndex) )
          this.$router.push(path)
      }
    }
  }
</script>

<style scoped lang="scss">
  .process {
    display: block;
    width: 100%;
    height: auto;
    max-height: 175px;

    ul {
      width: 100%;
      margin: 0;
      padding: 0;
      > li {
        float: left;
        list-style: none;
        > span {
          display: block;
          padding: 30px 30px 30px 0;
          line-height: 40px;
          font-family: $font-base;
          font-size: 0.85rem;
          font-weight: bold;
          text-decoration: none;
          color: $color-yellow-3;
          cursor: pointer;
        }
        &.active > span {
          color: $color-primary;
        }
      }
    }
  }
</style>
